import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { cardPaint } from "@/components/shapes/shared/card-paint";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { flightFields, hasFlight } from "./flight-content";
import { FlightFace } from "./flight-face";

/** A flight: its face (`FlightFace`) in the flight paint. */
export function FlightCardPreview(props: CardPreviewProps) {
  const fields = flightFields(props.source);
  if (!hasFlight(fields)) return <GenericCardPreview {...props} />;
  return (
    <FlightFace
      fields={fields}
      density={props.density}
      paint={cardPaint(props.frame).background}
      testIdPrefix="flight-card"
    />
  );
}
